import "./Navbar.css"
import {useRef} from "react";
import {FaBars, FaTimes} from "react-icons/fa";

const Navbar = () => {
    const navRef = useRef();

    const showNavbar = () => {
        navRef.current.classList.toggle("responsive_nav");
    }

    return (
        <div className="nav-container">
        <header>
            <h3>Alola!</h3>
            <nav ref={navRef}>
                <a onClick={showNavbar} href="#home"><i class="bi bi-person nav-icon"></i>Home</a> 
                <a onClick={showNavbar} href="#projects"><i class="bi bi-code-slash nav-icon"></i>Projects</a>       
                <a onClick={showNavbar} href="#skills"><i class="bi bi-tools nav-icon"></i>Skills</a>        
                <a onClick={showNavbar} href="#edu"><i class="bi bi-book nav-icon"></i>Education</a>
                <a onClick={showNavbar} href="#contact"><i class="bi bi-envelope nav-icon"></i>Contact Me</a>
                <button className="nav-btn nav-close-btn " onClick={showNavbar}>
                    <FaTimes />
                </button>
            </nav>
            <button className="nav-btn" onClick={showNavbar}>
                <FaBars />
            </button>
        </header>
        </div>
    )
}

export default Navbar;
